import { get } from "lodash/fp";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Button,
  ButtonToolbar,
  Container,
  Content,
  FlexboxGrid,
  Form,
  Message,
  Panel,
  Schema,
} from "rsuite";
import { ResetPasswordServices } from "../../../core/services/ResetPasswordServices";
import { GlobalRoutes } from "../../../navigation/NavConstant";
import "./ForgotPassword.css";

export function ForgotPassword() {
  const [formValue, setFormValue] = useState<any>({
    email: "",
  });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  async function generateLink(valid: boolean, event: any) {
    try {
      setError("");
      setMessage("");
      setLoading(true);
      if (valid) {
        let response: any = await ResetPasswordServices.generateLink(formValue);
        setMessage(get("data.message", response));
      }
      setLoading(false);
    } catch (error: any) {
      setError(get("message", error));
      setLoading(false);
      console.log(error);
    }
  }

  const model = Schema.Model({
    email: Schema.Types.StringType().isRequired(
      t("REQUIRED", {
        field: t("EMAIL").toLowerCase(),
      })
    ),
  });

  return (
    <div className="show-fake-browser forgot-password login">
      <Container className="container">
        <Content>
          <FlexboxGrid justify="center">
            <FlexboxGrid.Item colspan={6} className="login-bx">
              <Panel header={<h3 className="text-center">{t("FORGOT_PASSWORD")}</h3>}>
                <Form
                  fluid
                  model={model}
                  onSubmit={generateLink}
                  onChange={(value: any) => setFormValue(value)}
                >
                  <Form.Group>
                    <Form.ControlLabel>{t("EMAIL")}</Form.ControlLabel>
                    <Form.Control name="email" />
                    <span className="text-success">{message}</span>
                  </Form.Group>
                  <Form.Group>
                    <ButtonToolbar className="space-between">
                      <Button
                        appearance="primary"
                        type="submit"
                        loading={loading}
                      >
                        {t("SUBMIT")}
                      </Button>
                      <Button
                        appearance="link"
                        onClick={() => navigate(GlobalRoutes.LOGIN)}
                      >
                        {t("LOGIN")}
                      </Button>
                    </ButtonToolbar>
                    {error && <Message type="error">{error}</Message>}
                  </Form.Group>
                </Form>
              </Panel>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Content>
      </Container>
    </div>
  );
}
